import { AbsoluteBreadcrumb as Breadcrumb } from "components/atoms/Breadcrumb";
import { useBreadcrumb } from "features/shared/hooks/useBreadcrumb";
import { Avatar } from "shared/components/atoms/Avatar";
import { Image } from "shared/components/atoms/Image";
import { OfficialBadge } from "shared/features/shared/components/OfficialBadge";
import { FortuneTeller } from "shared/types";

interface Props {
  fortuneTeller: FortuneTeller;
}

export const BackgroundImageHeader = ({ fortuneTeller }: Props) => {
  const breadCrumbItems = useBreadcrumb([
    {
      name: fortuneTeller?.name,
      item: `/fortune_tellers/list/${fortuneTeller?.id}`,
    },
  ]);

  return (
    <div tw="relative">
      <Image
        src={fortuneTeller?.bannerUrl}
        fallback={fortuneTeller?.processedBannerUrl}
        layout="dynamic"
        objectFit="cover"
        tw="h-[164px]"
      />
      <div tw="absolute inset-0">
        <Breadcrumb itemListElements={breadCrumbItems} transparent />
        <div
          tw="absolute left-1/2 -bottom-12 rounded-full"
          css={[{ border: `6px solid white`, transform: `translateX(-50%)` }]}
        >
          <div tw="relative">
            <Avatar
              src={fortuneTeller?.imageUrl}
              fallback={fortuneTeller?.thumbnailUrl}
              size={100}
            />
            {fortuneTeller?.isOfficial && (
              <div tw="absolute bottom-0 right-0.5 w-6 h-6 z-10">
                <OfficialBadge size={24} />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
